import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { Button, TextField } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useHistory, useParams } from "react-router-dom";
import { getTextById, updateText, getEmailIds, getEmailPreview } from "../../../../api/text";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import Editor from "../../../components/editor/Editor";

function getEmptyText() {
  return {
    title: {},
    content: {},
  };
}

export default function EditTextsPage() {
  const [text, setText] = useState(getEmptyText());
  const [isEmailTemplate, setIsEmailTemplate] = useState(false);
  const textId = useParams().id;
  const history = useHistory();

  function openPreviewWindow() {
    if (!textId) return;
    getEmailPreview(textId, "es")
      .then((res) => {
        if (res.status === 200 && res.data) {
          const { subject, html } = res.data;
          const win = window.open("", "_blank");
          if (win) {
            win.document.write(
              `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${subject || "Vista previa email"}</title></head><body style="margin:0;padding:16px;">${html || ""}</body></html>`
            );
            win.document.close();
          }
        }
      })
      .catch((err) => {
        alertError({ error: err, customMessage: "No se pudo cargar la vista previa." });
      });
  }

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    if (!textId) {
      disableLoadingData();
      alertError({ error: null, customMessage: "Could not get text." });
      return history.push("/texts");
    }
    getTextById(textId)
      .then((res) => {
        if (res.status === 200) {
          setText(res.data);
          disableLoadingData();
        }
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not get text." });
        history.push("/texts");
      });
  }, [textId, disableLoadingData, history]);

  useEffect(() => {
    getEmailIds()
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data)) {
          setIsEmailTemplate(res.data.includes(textId));
        }
      })
      .catch(() => setIsEmailTemplate(false));
  }, [textId]);

  function saveText() {
    updateText(textId, text)
      .then((res) => {
        if (res.status === 200) {
          alertSuccess({
            title: "Saved!",
            customMessage: "Changes successfully saved.",
          });
          history.push("/texts");
        }
      })
      .catch((error) => {
        alertError({ error: error, customMessage: "Could not save changes." });
      });
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;
      if (!text[element]) text[element] = {};
      let newText = text[element];
      newText[lang] = event.target.value;
      setText({ ...text, [element]: newText });
    } else setText({ ...text, [element]: event.target.value });
  };

  const handleChangeEditor = (element, lang, value) => {
    if (lang) {
      if (value === " ") return;
      if (!text[element]) text[element] = {};
      let newText = text[element];
      newText[lang] = value;
      setText({ ...text, [element]: newText });
    } else setText({ ...text, [element]: value });
  };

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save, Preview (solo plantillas email) y Delete */}
                <div className="d-flex gap-2">
                  {isEmailTemplate && (
                    <Button
                      onClick={openPreviewWindow}
                      variant="outlined"
                      size="medium"
                      startIcon={<VisibilityIcon />}
                    >
                      Vista previa correo
                    </Button>
                  )}
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderMultilanguageTabContent = (lang) => {
    return (
      <>
        <TextField
          id={`title`}
          label="Title"
          value={(text.title && text.title[lang]) || ""}
          onChange={handleChange("title", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
        <Editor
          body={(text.content && text.content[lang]) || ""}
          setBody={(new_body) => handleChangeEditor("content", lang, new_body)}
          className="max-height"
          lang={lang}
          placeholder={"Enter text content here..."}
        />
      </>
    );
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/texts"),
            onSave: saveText,
            showDelete: false,
            setObj: setText,
            obj: text,
          })}
          <CardHeader title="Edit text"></CardHeader>
          <CardBody>
            <MultilanguageTabBlock
              multilanguageTabContent={renderMultilanguageTabContent}
            />
          </CardBody>
        </Card>
      </>
    );
}
